import { createAsyncThunk } from "@reduxjs/toolkit";

import { getAttendanceData } from "@/apis/authApis";
import {
  addTimeSheetDataApi,
  getTimeSheetApi,
  deleteTimeSheetApi,
  updateTimeSheetApi,
  getTimeSheetReportApi,
  getTimeSheetUnfilledReportApi,
  getTimesheetReportHoursForSpecificJobApi,
  emailAllUserTimesheetReportApi,
  getTimeSheetSummaryReportApi,
  getTimeSheetCalendarReportApi,
  getAllUserTimeSheetReportApi,
  getSingleUserTimeSheetReportApi,
  emailAllUserAttendanceReportApi,
  getTimesheetVsSchedulingMonthlyReportApi,
  emailTimesheetVsSchedulingMonthlyReportApi,
  clientWiseUserTimeSheetReportApi,
  emailClientWiseTimeSheetReportApi,
  addRegularizeApi,
  clientWiseMonthlyTimeSheetReportApi,
  monthWiseTimeSheetReportApi,
  getOpenJobChargedHoursTimesheetApi,
  getTimeSheetStatustApi,
  getUserWisePayrollReportApi,
  getAttendanceDetailsApi,
  getUserScheduledHourApi,
} from "@/apis/timeSheetApis";

import type { GetAttendanceTimePayloadType } from "@/commonTypes/authTypes";
import type {
  GetScheduledJobsHourPayloadType,
  GetUserScheduledHoursPayloadType,
} from "@/commonTypes/schedulingTypes";
import type {
  AddEditTimeSheetDataPayloadType,
  AddRegularizePayloadType,
  DeleteTimeSheetDataPayloadType,
  EmailAllUserTimesheetReportPayloadType,
  EmailTimesheetVsSchedulingMonthlyReportType,
  GetAllUserAttendanceReportDataPayloadType,
  GetClientWiseMonthlyReportPayloadType,
  GetMissingTimesheetSummaryReport,
  GetSingleUserAttendanceReportDataPayloadType,
  GetTimeSheetDataPayloadType,
  GetTimeSheetReportDataPayloadType,
  GetTimeSheetSummaryClientWiseUserPayloadType,
  GetTimeSheetSummaryReportDataPayloadType,
  GetTimeSheetUserWorkOnSpecificJobPayloadType,
  GetTimesheetVsSchedulngMonthlyReport,
} from "@/commonTypes/timeSheetTypes";

export const addTimeSheetAction = createAsyncThunk(
  "timeSheet/add",
  async (data: AddEditTimeSheetDataPayloadType) => {
    const response = await addTimeSheetDataApi(data);
    return response.data;
  }
);

export const getTimeSheetDataAction = createAsyncThunk(
  "timeSheet/get",
  async (data: GetTimeSheetDataPayloadType) => {
    const response = await getTimeSheetApi(data);
    return response.data;
  }
);

export const deleteTimeSheetAction = createAsyncThunk(
  "timeSheet/delete",
  async (data: DeleteTimeSheetDataPayloadType) => {
    const response = await deleteTimeSheetApi(data);
    return response.data;
  }
);

export const editTimeSheetAction = createAsyncThunk(
  "timeSheet/edit",
  async (data: AddEditTimeSheetDataPayloadType) => {
    const response = await updateTimeSheetApi(data);
    return response.data;
  }
);

export const getTimeSheetReportDataAction = createAsyncThunk(
  "timeSheetReport/get",
  async (data: GetTimeSheetReportDataPayloadType) => {
    const response = await getTimeSheetReportApi(data);
    return response.data;
  }
);

export const getTimeSheetCalendarReportDataAction = createAsyncThunk(
  "timeSheetCalendarReport/get",
  async (data: GetTimeSheetReportDataPayloadType) => {
    const response = await getTimeSheetCalendarReportApi(data);
    return response.data;
  }
);

export const getTimeSheetUserReportAction = createAsyncThunk(
  "timeSheetUserReport/get",
  async (data: GetTimeSheetReportDataPayloadType) => {
    const response = await getTimeSheetReportApi(data);
    return response.data;
  }
);

export const getTimeSheetUnfilledReportAction = createAsyncThunk(
  "timeSheetUnfilledReport/get",
  async (data: GetMissingTimesheetSummaryReport) => {
    const response = await getTimeSheetUnfilledReportApi(data);
    return response.data;
  }
);

export const getTimesheetReportHoursForSpecificJobAction = createAsyncThunk(
  "timesheet/reportForSpecificJob",
  async (data: GetTimeSheetUserWorkOnSpecificJobPayloadType) => {
    const response = await getTimesheetReportHoursForSpecificJobApi(data);
    return response.data;
  }
);

export const emailAllUserTimesheetReportAction = createAsyncThunk(
  "timesheet/emaillAllUserTimesheetReport",
  async (data: EmailAllUserTimesheetReportPayloadType) => {
    const response = await emailAllUserTimesheetReportApi(data);
    return response.data;
  }
);

export const getTimeSheetSummaryReportAction = createAsyncThunk(
  "timeSheetSummaryReport/get",
  async (data: GetTimeSheetSummaryReportDataPayloadType) => {
    const response = await getTimeSheetSummaryReportApi(data);
    return response.data;
  }
);

export const getAllUserAttendanceReportAction = createAsyncThunk(
  "allUserAttendanceReport/get",
  async (data: GetAllUserAttendanceReportDataPayloadType) => {
    const response = await getAllUserTimeSheetReportApi(data);
    return response.data;
  }
);

export const getAllUserPayrollReportAction = createAsyncThunk(
  "allUserPayrollReport/get",
  async (data: GetAllUserAttendanceReportDataPayloadType) => {
    const response = await getUserWisePayrollReportApi(data);
    return response.data;
  }
);

export const getAttendanceDetailsAction = createAsyncThunk(
  "get/attendanceDetails",
  async (data: { token: string; date: string }) => {
    const response = await getAttendanceDetailsApi(data);
    return response.data;
  }
);

export const getSingleUserAttendanceReportAction = createAsyncThunk(
  "attendanceReport/get",
  async (data: GetSingleUserAttendanceReportDataPayloadType) => {
    const response = await getSingleUserTimeSheetReportApi(data);
    return response.data;
  }
);

export const getSingleAttendanceDetailAction = createAsyncThunk(
  "SingleAttendanceReportDetails/get",
  async (data: GetAttendanceTimePayloadType) => {
    const response = await getAttendanceData(data);
    return response.data;
  }
);

export const emailAllUserAttendanceReportAction = createAsyncThunk(
  "timesheet/emailAllUserAttendanceReport",
  async (data: EmailAllUserTimesheetReportPayloadType) => {
    const response = await emailAllUserAttendanceReportApi(data);
    return response.data;
  }
);

export const getTimeSheetVsSchedulingMonthlyReportAction = createAsyncThunk(
  "timeSheetVsSchedulingMonthlyReport/get",
  async (data: GetTimesheetVsSchedulngMonthlyReport) => {
    const response = await getTimesheetVsSchedulingMonthlyReportApi(data);
    return response.data;
  }
);

export const emailTimesheetVsSchedulingMonthlyReportAction = createAsyncThunk(
  "timesheet/emailTimeSheetVsSchedulingMonthlyReport",
  async (data: EmailTimesheetVsSchedulingMonthlyReportType) => {
    const response = await emailTimesheetVsSchedulingMonthlyReportApi(data);
    return response.data;
  }
);

export const getClientWiseUserTimeSheetReportAction = createAsyncThunk(
  "timesheet/clientWiseUserTimeSheetReport",
  async (data: GetTimeSheetSummaryClientWiseUserPayloadType) => {
    const response = await clientWiseUserTimeSheetReportApi(data);
    return response.data;
  }
);

export const emailTimesheetClientWiseTimeSheetReportAction = createAsyncThunk(
  "timesheet/emailClientWiseTimeSheetReport",
  async (data: EmailTimesheetVsSchedulingMonthlyReportType) => {
    const response = await emailClientWiseTimeSheetReportApi(data);
    return response.data;
  }
);

export const addRegularizeAction = createAsyncThunk(
  "regularize/add",
  async (data: AddRegularizePayloadType) => {
    const response = await addRegularizeApi(data);
    return response.data;
  }
);
export const getClientWiseMonthlyTimeSheetReportAction = createAsyncThunk(
  "timesheet/clientWiseMonthlyTimeSheetReport",
  async (data: GetClientWiseMonthlyReportPayloadType) => {
    const response = await clientWiseMonthlyTimeSheetReportApi(data);
    return response.data;
  }
);

export const getMonthWiseTimeSheetReportAction = createAsyncThunk(
  "timesheet/monthWiseTimeSheetReport",
  async (data: GetClientWiseMonthlyReportPayloadType) => {
    const response = await monthWiseTimeSheetReportApi(data);
    return response.data;
  }
);

export const getOpenJobChargedHoursTimesheetAction = createAsyncThunk(
  "get/timeSheetChargedHours",
  async (data: GetScheduledJobsHourPayloadType) => {
    const response = await getOpenJobChargedHoursTimesheetApi(data);
    return response.data;
  }
);

export const getTimeSheetStatus = createAsyncThunk(
  "get/timeSheetStatus",
  async (data: string) => {
    const response = await getTimeSheetStatustApi(data);
    return response.data;
  }
);

export const getUserScheduledHoursAction = createAsyncThunk(
  "get/scheduledHours",
  async (data: GetUserScheduledHoursPayloadType) => {
    const response = await getUserScheduledHourApi(data);
    return response.data;
  }
);
